import { createFileRoute, redirect } from "@tanstack/react-router";
import { getStoredUserRole } from "@/shared/infrastructure/auth/token-storage";
import { AdminDashboardPage } from "@/modules/admin/presentation/pages/AdminDashboardPage";

export const Route = createFileRoute("/_authenticated/admin-users")({
  beforeLoad: () => {
    if (getStoredUserRole() !== "admin") {
      throw redirect({ to: "/" });
    }
  },
  component: AdminDashboardPage,
});
